import { RouteVolume } from '../../../MineModel/Route/volumeUtils';

export type MeasureMode = 'node-to-node' | 'spool-click' | 'route' | 'route-volume';
export type BgColour = '#000000' | '#ffffff';

export interface MeasureLineEndpoints {
  aNodeId: string;
  bNodeId: string;
}

export interface MeasureLabel {
  position: { x: number; y: number; z: number };
  text: string;
  referenceLength: number;
}

export interface MeasureState {
  measureMode: MeasureMode;
  measureActive: boolean;
  selectedNodeIds: string[];
  spoolResult: number | null;
  nodeToNodeResult: number | null;
  routeResult: number | null;
  routeVolumeResult: RouteVolume | null;
  routeNoPathFound: boolean;
  backgroundColour: BgColour;
  measureLineEndpoints: MeasureLineEndpoints | null;
  routeHighlightSpoolIds: string[];
  measureLabel: MeasureLabel | null;
}

const defaultState: MeasureState = {
  measureMode: 'route',
  measureActive: false,
  selectedNodeIds: [],
  spoolResult: null,
  nodeToNodeResult: null,
  routeResult: null,
  routeVolumeResult: null,
  routeNoPathFound: false,
  backgroundColour: '#000000',
  measureLineEndpoints: null,
  routeHighlightSpoolIds: [],
  measureLabel: null,
};

// Every measurement output, blanked. Spread this wherever results are discarded so a new
// result field only has to be added in one place.
export const emptyMeasureResults = (): Partial<MeasureState> => ({
  selectedNodeIds: [],
  spoolResult: null,
  nodeToNodeResult: null,
  routeResult: null,
  routeVolumeResult: null,
  routeNoPathFound: false,
  measureLineEndpoints: null,
  routeHighlightSpoolIds: [],
  measureLabel: null,
});

let measureState: MeasureState = { ...defaultState };

const stateListeners: Set<() => void> = new Set();

export const getMeasureState = () => measureState;

export const updateMeasureState = (updates: Partial<MeasureState>) => {
  measureState = { ...measureState, ...updates };
  stateListeners.forEach((listener) => listener());
};

export const subscribeToMeasureState = (listener: () => void): (() => void) => {
  stateListeners.add(listener);
  return () => { stateListeners.delete(listener); };
};

export const deactivateMeasure = () => {
  updateMeasureState({ ...emptyMeasureResults(), measureActive: false });
};

export const resetMeasureState = () => {
  measureState = { ...defaultState };
  stateListeners.forEach((listener) => listener());
};
